import { userRoles } from '../../utils/userRoles'

type UserRole = string
type StatusId = number

export type SendAction = 'sendToReview' | 'changeOwnership' | 'takeOver' | null

export const SEND_ACTIONS = {
  sendToReview: 'sendToReview',
  changeOwnership: 'changeOwnership',
  takeOver: 'takeOver',
  none: null,
} as const

const technicianLikeRoles: UserRole[] = [userRoles.FieldTechnician, userRoles.Admin]

export const getSendAction = ({
  userRoleSelected,
  statusId,
  inProcessStatusId,
  canTakeOver = false,
}: {
  userRoleSelected: UserRole
  statusId: StatusId
  inProcessStatusId: StatusId
  canTakeOver?: boolean
}): SendAction => {
  if (canTakeOver) return SEND_ACTIONS.takeOver
  if (technicianLikeRoles.includes(userRoleSelected) && statusId === inProcessStatusId) {
    return SEND_ACTIONS.sendToReview
  }
  if ([userRoles.Auditor, ...technicianLikeRoles].includes(userRoleSelected)) {
    return SEND_ACTIONS.changeOwnership
  }
  return SEND_ACTIONS.none
}

export const canEditFarmSubdivisionDocuments = (userRoleSelected: UserRole): boolean =>
  technicianLikeRoles.includes(userRoleSelected)
